import { BALANCE_CONSUMED_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { fetchOriginalBalanceByTagsSuccess, fetchOriginalBalanceByTagsFailure } from "./reducer"

export const fetchOriginalBalanceByTags = (setLoading, tag) => async (dispatch) => {
    setLoading(true)
    const graphqlQuery = {
        query: "query ConsumedBalanceByTags($tags: [String!]!) {\n  ConsumedBalanceByTags(tags: $tags) {\n    tag\n    energyCost\n  }\n}",
        variables: { tags: tag },
    }

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            `${BALANCE_CONSUMED_API}`,
            'POST',
            graphqlQuery
        );
        setLoading(true)
        const OriginalBalanceByTags = response?.data?.ConsumedBalanceByTags
        dispatch(fetchOriginalBalanceByTagsSuccess(OriginalBalanceByTags))
    } catch (error) {
        dispatch(fetchOriginalBalanceByTagsFailure(error.message))
    } finally {
        setLoading(false)
    }
}

